import { render, staticRenderFns } from "./ClassificationTypeColumn.vue?vue&type=template&id=6298428b&scoped=true&"
import script from "./ClassificationTypeColumn.vue?vue&type=script&lang=js&"
export * from "./ClassificationTypeColumn.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationTypeColumn.vue?vue&type=style&index=0&id=6298428b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6298428b",
  null
  
)

export default component.exports